import { render, staticRenderFns } from "./ContactViewGroups.vue?vue&type=template&id=3c8a4841"
import script from "./ContactViewGroups.vue?vue&type=script&lang=js"
export * from "./ContactViewGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports